// components/list/List.tsx
import { ComplexOrderInterface } from '../../../../../common/types/interfaces'
import { Item } from '../item/Item'
import classes from './List.module.sass'

type Props = {
  startEdit: (el: ComplexOrderInterface) => void
  showDetails: (el: ComplexOrderInterface) => void
  list: ComplexOrderInterface[] | []
  loading: boolean
}

export const List = ({ startEdit, list, showDetails, loading }: Props) => {
  return (
    <div className={classes.container}>
      {!list || !Array.isArray(list) || (!list.length && !loading) ? (
        <div className={classes.Message}>Нет заявок</div>
      ) : (
        list.map((el: ComplexOrderInterface) => (
          <Item showDetails={showDetails} el={el} startEdit={startEdit} key={el.id} />
        ))
      )}
    </div>
  )
}
